var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLhwsBillboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st56 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st57 {\n        fill: #7289ad;\n      }\n\n      .st58 {\n        fill: url(#linear-gradient);\n        stroke: #adb4cc;\n        stroke-miterlimit: 10;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 34.9,
    y1: -598.5,
    x2: 34.9,
    y2: -684.3,
    gradientTransform: "translate(0 -607) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcfcfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cae7f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: -19.3,
    y1: -624,
    x2: 77.8,
    y2: -624,
    gradientTransform: "translate(0 -607) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcfcfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2f2f3",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color_Blocks"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M60.1,69H9.9c-5,0-9.1-4.1-9.1-9.1V10.1C.9,5,4.9,1,9.9,1h50.1c5,0,9.1,4.1,9.1,9.1v49.9c0,5-4,9-9,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M35,24.3c12.1,0,23.6,3,33.6,8.2V10.1c0-4.7-3.8-8.6-8.6-8.6H9.9C5.2,1.5,1.3,5.3,1.3,10.1v22.5c10.1-5.3,21.6-8.3,33.7-8.3Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st57",
    x: 16,
    y: 39.7,
    width: 14.2,
    height: 2.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st57",
    x: 39.9,
    y: 39.7,
    width: 14.2,
    height: 2.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "38.1 39.7 32 39.7 32 58.5 30.2 58.5 30.2 61.7 32 61.7 38.1 61.7 39.9 61.7 39.9 58.5 38.1 58.5 38.1 39.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M51.1,15.1v-2.4h3v-2.6h-7.7v2.6h3v2.4h-13.5v-2.4h3v-2.6h-7.7v2.6h3v2.4h-13.5v-2.4h3v-2.6h-7.7v2.6h3v2.4h-6.9v23.5h45.9V15.1h-6.9ZM55.6,36.5H14.5v-19.3h41.1v19.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M29.3,29.5h3.1l.6,2h2l-3-8.6h-2.2l-3,8.6h2l.5-2ZM30.9,24.2c0,.1.1.3.2.6s.4,1.3,1,3.1h-2.2c.5-1.9.9-3.2,1-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M42,30.4c.8-.8,1.2-1.8,1.2-3.2s-.4-2.4-1.2-3.1-1.9-1.1-3.3-1.1h-2.7v8.6h2.4c1.7,0,2.8-.5,3.6-1.2ZM37.9,24.4h1c1.6,0,2.4.9,2.4,2.8s-.9,2.8-2.6,2.8h-.8s0-5.6,0-5.6Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLhwsBillboard);
export default __webpack_public_path__ + "static/media/lhws-billboard.8486741598a249ff423cb52f9fe835a4.svg";
export { ForwardRef as ReactComponent };